import * as React from 'react';
import useCheckout from '../../../../../hooks/adyen/useCheckout.js';
import { AdyenPaymentType } from '../../../../../models/adyen/payment-type.js';
import { PaymentMethodFormContainer } from '../PaymentMethodForm/containers/PaymentMethodFormContainer.js';

var _ownerName, _iban;
const toPaymentMethodFormState = (state)=>({
        isValid: state.isValid,
        data: {
            'sepa.ownerName': (_ownerName = state.data.paymentMethod.ownerName) !== null && _ownerName !== void 0 ? _ownerName : '',
            'sepa.ibanNumber': (_iban = state.data.paymentMethod.iban) !== null && _iban !== void 0 ? _iban : ''
        }
    })
;
const SepaContainer = ({ onChange  })=>{
    const setSepaState = React.useCallback((state)=>onChange(toPaymentMethodFormState(state))
    , [
        onChange
    ]);
    const checkout = useCheckout(setSepaState);
    return /*#__PURE__*/ React.createElement(PaymentMethodFormContainer, {
        type: AdyenPaymentType.Sepa,
        checkout: checkout
    });
};

export { SepaContainer };
//# sourceMappingURL=SepaContainer.js.map
